exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-grabar {\n  background-color: #ff6c00 !important;\n  color: white !important;\n}\n", ""]);

// exports
